/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/30/21
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import ScenarioSelectMenu from './ScenarioSelectMenu';
import { selectInventoryScenarioMenuItems } from 'selectors/entities/inventories';

const mapStateToProps = (state, ownProps) => ({
  items: ownProps.inventoryId
    ? selectInventoryScenarioMenuItems(state, {
      inventoryId: ownProps.inventoryId,
    })
    : [],
});

export default connect(mapStateToProps)(ScenarioSelectMenu);



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryPageControlForm/ScenarioSelectMenu/index.js